import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { formatAriaProperties } from '@dojo/widgets/common/util';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { cssProperty } from '@holmescorp/middleware/css-property';
import { createNlsMiddleware } from '@holmescorp/lcc-state';

import css from '../css/assess-viz.m.css';

export interface AssessVizProperties {
	title: string;
	percent: number;
	assess: number;
	xqa: string;
}

const nls = createNlsMiddleware('ditabook');
const factory = create({ nls, theme, cssProperty }).properties<AssessVizProperties>();

const lang = window.hcstatic.portal_language || 'en';
const num = new Intl.NumberFormat('en', { style: 'decimal', maximumSignificantDigits: 2 });
const pct = new Intl.NumberFormat(lang, { style: 'percent', maximumSignificantDigits: 2 });

export const AssessViz = factory(({ properties, middleware: { nls, theme, cssProperty } }) => {
	const {
		messages: {
			prepost_viz_score = '[ditabook] prepost_viz_score',
			prepost_viz_pretest = '[ditabook] prepost_viz_pretest'
		}
	} = nls();
	const { xqa, title, percent, assess } = properties();
	const scorePercent = cssProperty.get('root', '--score-percent');
	if (scorePercent !== num.format(percent)) {
		cssProperty.set('root', '--score-percent', num.format(percent));
		cssProperty.set('root', '--assess-percent', num.format(assess));
	}
	const barScore = pct.format(parseFloat(percent.toFixed(2)));
	const assessScore = pct.format(parseFloat(assess.toFixed(2)));
	const diffpct = percent - assess;
	const diff = `${diffpct < 0 ? '' : '+'}${pct.format(parseFloat(diffpct.toFixed(2)))}`;

	const themeCss = theme.classes(css);
	return v('div', { key: 'root', role: 'listitem', xqa, classes: [themeCss.root] }, [
		v(
			'div',
			{ key: 'title', classes: [themeCss.title], role: 'heading', ...formatAriaProperties({ level: '2' }) },
			[title]
		),
		v('div', { key: 'wrapper', classes: [themeCss.wrapper] }, [
			v('div', { key: 'field', classes: [themeCss.field] }, [v('div', { key: 'bar', classes: [themeCss.bar] })]),
			v('div', { key: 'assess', 'aria-hidden': 'true', classes: [themeCss.assess] }, ['\u2666']),
			v(
				'div',
				{ key: 'bar-score', xqa: 'viz score', 'aria-label': prepost_viz_score, classes: [themeCss.barscore] },
				[`${barScore} ( ${diff} )`]
			),
			v(
				'div',
				{
					key: 'assess-score',
					xqa: 'viz assess',
					'aria-label': prepost_viz_pretest,
					classes: [themeCss.assessScore]
				},
				[`${assessScore}`]
			)
		])
	]);
});
